import { useState, useCallback, ReactNode } from 'react';
import type mapboxgl from 'mapbox-gl';
import { MapContext } from './MapContext';

export function MapProvider({ children }: { children: ReactNode }) {
  const [map, setMap] = useState<mapboxgl.Map | null>(null);

  const handleSetMap = useCallback((mapInstance: mapboxgl.Map | null) => {
    setMap(mapInstance);
  }, []);

  return (
    <MapContext.Provider value={{ map, setMap: handleSetMap }}>
      {children}
    </MapContext.Provider>
  );
}
